module.exports = __webpack_public_path__ + "img/ballad-in-goblets-3.93012a97.webp";